





















































































import { Component, Vue } from 'vue-property-decorator'
import MenuTree from '@/components/MenuTree.vue'
import Notifications from '@/components/Notifications.vue'
import dataService, { InitData } from '../services/dataService'
import store from '../store'
import ws, { SocketMsg } from '../services/socket'
import { Route } from 'vue-router'
import Menus, { MenuTreeNode } from '@/services/menuData'

let isHomePage = false
@Component({
  components: {
    menuTree: MenuTree,
    notifications: Notifications
  }
})
export default class Home extends Vue {
  initData: InitData = {
    Notification: { Count: 0 }
  }

  showMenu = true
  isHome = isHomePage
  msg = ''
  menus: MenuTreeNode[] = Menus
  currentRouteName: string
  runningInterval: number
  notVisible = false

  async mounted () {
    this.initSocket()
    if (this.runningInterval) {
      clearInterval(this.runningInterval)
    }
    this.runningInterval = setInterval(() => {
      ws.Server.sendDirectMsg('sendPing', '')
      if (this.$router.currentRoute) {
        if (this.currentRouteName !== this.$router.currentRoute.path) {
          this.currentRouteName = this.$router.currentRoute.path
        }
      }
    }, 20000)
    window.addEventListener('beforeunload', (evt: Event) => {
      ws.Server.close()
    })
    await this.loadNotifications()
  }

  async loadNotifications () {
    const res = await dataService.getInitData()
    this.initData = res.Result
    if (res.Result) {
      this.notificationCount = res.Result.Notification.Count
    }
  }

  get userEmail () {
    return this.$store.state.user.email
  }

  get notificationCount () {
    return this.$store.state.notificationCount
  }

  set notificationCount (v) {
    store.commit('setNotificationCount', v)
  }

  beforeRouteEnter (to: Route, from: Route, next: () => void) {
    isHomePage = (to.fullPath === '/')
    next()
  }

  beforeRouteUpdate (to: Route, from: Route, next: () => void) {
    this.isHome = (to.name === 'home')
    next()
  }

  destroyed () {
    ws.Server.removeMessageCallBack(this.msgCallBack)
    console.log('home destroyed')
  }

  msgCallBack (msg: SocketMsg) {
    console.log(msg)
  }

  initSocket () {
    ws.Server.init()
    ws.Server.addMessageCallBack(this.msgCallBack)
  }

  closeSocket () {
    ws.Server.close()
    this.msg = 'Closed'
  }

  logout () {
    store.commit('setUser', null)
    sessionStorage.removeItem('jwt')
    localStorage.removeItem('jwt')
    this.closeSocket()
    this.$router.push('/')
  }
}
